import styled from 'styled-components';
import { SectionParent } from '../../../components/StyledComponents';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import CustomBg from '../../../assets/v2/CustomHardware/CustomBg.png';
import esper from '../../../assets/v2/CustomHardware/esper.svg';
import mediatek from '../../../assets/v2/CustomHardware/mtklogo.svg';
import CustomBgMobile from '../../../assets/v2/CustomHardware/CustomBgMobile.png';
import { Title } from '../HomePage/HomepageSectionOne';

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  margin-top: 3rem;
  padding-top: 0rem !important;
  background: url(${CustomBg});
  height: 45rem;
  background-position: right;
  background-size: cover;
  width: 100%;
  display: grid;
  @media (max-width: 768px) {
    padding-top: 8rem !important;
    background: url(${CustomBgMobile});
    background-size: 100%;
    height: 174vw;
    align-content: baseline;
  }
  @media (max-width: 520px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 320px) {
    padding-top: 11rem !important;
  }
`;

const SectionItemContainer = styled.div`
  grid-template-columns: repeat(5, 1fr);
  display: grid;

  @media (max-width: 768px) {
    padding-top: 10%;
  }
`;

const SectionOneTitle = styled(Title)`
  line-height: 1.21;
  color: #ffffff;
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const GridLeft = styled.div`
  grid-column: span 2;
  /* padding-left: 3rem; */
  margin-top: 3rem;
  align-content: center;
  padding-bottom: 3rem;
  padding-left: 4rem;
  display: grid;
  @media (max-width: 768px) {
    grid-column: span 5;
    padding-right: 0rem;
    margin-top: -7rem;
    padding-left: 0rem;
    min-height: 15rem;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 2rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  color: #ffffff;
  @media (max-width: 768px) {
    text-align: center;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    font-size: 12px;
    margin-bottom: -1rem;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  padding-bottom: 1rem;
  margin-bottom: 0rem;
  @media (max-width: 768px) {
    justify-self: center;
    padding-left: 2rem;
    padding-bottom: 2rem;
    margin-bottom: 0.5rem;
  }
`;
const Divider = styled.div`
  width: 2px;
  height: 2rem;
  background-color: #ffffff;
  margin: 0 1rem;
`;
const ImageContainer = styled(LazyLoadImage)`
  width: fit-content;
  height: fit-content;
  @media (max-width: 520px) {
    width: 40%;
  }
`;
export default () => (
  <div style={{ zIndex: 1, position: 'relative', background: '#14183d' }}>
    <div style={{ height: '3rem', background: '#14183d' }} />
    <SectionOne>
      <SectionItemContainer>
        <GridLeft>
          <LogoContainer>
            <ImageContainer src={esper} style={{ marginTop: '-10px' }} />
            <Divider />
            <ImageContainer src={mediatek} />
          </LogoContainer>
          <SectionOneTitle>
            Accelerate Your Custom Device Development with Esper and MediaTek
          </SectionOneTitle>
          <HeroSubTitle style={{ paddingTop: '1rem' }}>
            Esper brings its full-stack, industry-leading Android device and
            application management platform with a complete developer toolchain
            to MediaTek’s Rich IOT Reference Designs on the road to 5G for your
            purpose-built devices.
          </HeroSubTitle>
        </GridLeft>
      </SectionItemContainer>
    </SectionOne>
  </div>
);
